import PlusIcon from 'assets/icons/plus';
import SubmissionTable from 'components/features/submission-table';
import UWDashboardTabs from 'components/features/uw-dashboard-tab';
import { EUWDashboardTab } from 'components/features/uw-dashboard-tab/types';
import CustomButton from 'components/ui/custom-button';
import { EButtonVariant } from 'components/ui/custom-button/enums';
import { ENavigationPath } from 'constants/path';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

const UWDashboard = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [activeUWDashboardTab, setActiveUWDashboardTab] = useState(
    EUWDashboardTab.OVERVIEW
  );
  return (
    <>
      <div>
        <div className="flex justify-between">
          <div className="flex gap-5 rounded-xl bg-[#E3F2FB]">
            <UWDashboardTabs
              activeTab={activeUWDashboardTab}
              setActiveTab={setActiveUWDashboardTab}
            />
          </div>
          <CustomButton
            variant={EButtonVariant.PRIMARY}
            label={t('submission.createNewSubmission')}
            prefixIcon={<PlusIcon color="#fff" />}
            onClick={() => navigate(ENavigationPath.NEW_SUBMISSION)}
            className="mt-0 px-4"
          />
        </div>
        <div className="bg-[#E3F2FB] p-[10px] rounded-lg my-[20px]">
          <SubmissionTable />
        </div>
      </div>
    </>
  );
};

export default UWDashboard;
